<template>
  <div class="page-content">
    <div class="row">
      <div class="col-12">
        <RidePerformances />
        <WeeklyBreakdown />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { nextTick, onMounted, defineAsyncComponent } from 'vue';
import { useRoute } from 'vue-router';

import util from '@/Utils/util';

const RidePerformances = defineAsyncComponent(() => import('./OperatorRidePerformances/RidePerformances.vue') as any);
const WeeklyBreakdown = defineAsyncComponent(() => import('./OperatorRidePerformances/WeeklyBreakdown.vue') as any);

onMounted(async () => {
  const route = useRoute();
  const { hash } = route;

  await nextTick();
  util.moveScrollComponent(hash);
});
</script>
